module.exports = "/_next/static/images/schedule_dashboard_empty-1491ad7b8ece4910c2e34599144b0d3e.svg";